import { flow3 } from '@code-expert/prelude';
import { aggregateOptionalSingleton, aggregatePublicationSet, aggregateSingleton, aggregateTrigger, } from '@code-expert/pubsub-common';
import { useObservable } from '@code-expert/react/src/useObservable.js';
import { toObservable } from './toObservable.js';
import { useTrigger } from './trigger.js';
const methodologies = {
    find: flow3(toObservable, aggregatePublicationSet()),
    findOne: flow3(toObservable, aggregateOptionalSingleton()),
    getOne: flow3(toObservable, aggregateSingleton()),
    trigger: flow3(toObservable, aggregateTrigger()),
};
export const makeUsePublication = (socket) => {
    // DO NOT INLINE - we need an assignment to a variable for it to have a `name` property
    const usePublication = (name, ...[opts]) => {
        const method = opts?.method ?? 'find';
        const methodology = methodologies[method];
        const getObservable = methodology(socket)(name);
        /* eslint-disable react-hooks/rules-of-hooks */
        return (method === 'trigger'
            ? useTrigger(useObservable(getObservable, opts))
            : useObservable(getObservable, opts));
        /* eslint-enable react-hooks/rules-of-hooks */
    };
    return usePublication;
};
//# sourceMappingURL=usePublication.js.map